import { useEffect } from 'react';

interface PageMeta {
  title: string;
  description: string;
  keywords: string;
  canonicalUrl: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
}

export function usePageMeta(meta: PageMeta) {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = meta.title;

    const setMetaTag = (name: string, content: string, property = false) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMetaTag('description', meta.description);
    setMetaTag('keywords', meta.keywords);

    const canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (canonical) canonical.setAttribute('href', meta.canonicalUrl);

    if (meta.ogTitle) setMetaTag('og:title', meta.ogTitle, true);
    if (meta.ogDescription) setMetaTag('og:description', meta.ogDescription, true);
    if (meta.ogType) setMetaTag('og:type', meta.ogType, true);
    setMetaTag('og:url', meta.canonicalUrl, true);

    setMetaTag('twitter:title', meta.ogTitle || meta.title, false);
    setMetaTag('twitter:description', meta.ogDescription || meta.description, false);

    return () => {
      document.title = prevTitle;
    };
  }, [meta]);
}